import { queryClient } from '../../../../../App'
import { useRemoteClientPut } from '../../../../../configs/http-client'
import { useLocalStorage } from '../../../../../remote/local-storage'
import { useToast } from '../../../../hooks'

export const updateTemplate = async (data: any) => {
  const { getUnitId } = useLocalStorage()
  const { httpClientPut } = useRemoteClientPut()
  const { showToast } = useToast()

  try {
    await httpClientPut(`/contratos?unidade=${getUnitId()}`, data)
    queryClient.refetchQueries({ queryKey: ['templates'] })
    showToast('Template Atualizado', 'success')
  } catch (error) {
    console.error(error)
    showToast('Erro ao atualizar o template', 'error')
  }
}
